<script setup lang="ts">
import { WrapperGeneralInfo } from '@shared/ui/wrappers'
import { CardAdmin } from '@shared/ui/cards'

import { useDisciplineGeneral } from '../model/discipline-general.hook'
import DisciplineGeneralTitle from './DisciplineGeneralTitle.vue'
import DisciplineGeneralControls from './DisciplineGeneralControls.vue'
import DisciplineGeneralInfo from './DisciplineGeneralInfo.vue'
import DisciplineGeneralBalance from './DisciplineGeneralBalance.vue'
import DisciplineGeneralNotes from './DisciplineGeneralNotes.vue'

defineOptions({
  name: 'DisciplineGeneral',
})

const {
  refTitle,
  refDetails,
  refIsCustomerGo,
  canViewDisciplines,
} = useDisciplineGeneral()
</script>

<template>
  <CardAdmin
    class="discipline-general"
    fullwidth
  >
    <template #title>
      <DisciplineGeneralTitle
        :title="refTitle"
        :is-go="refIsCustomerGo"
        :brand="refDetails?.customer?.brand ?? null"
      />
    </template>
    <template #header>
      <DisciplineGeneralControls
        v-if="canViewDisciplines"
      />
    </template>
    <WrapperGeneralInfo>
      <template #info>
        <DisciplineGeneralInfo />
      </template>
      <template
        v-if="canViewDisciplines"
        #additional
      >
        <DisciplineGeneralBalance />
        <DisciplineGeneralNotes />
      </template>
    </WrapperGeneralInfo>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./DisciplineGeneral.scss" />
